var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "filterColumn relative", style: { textAlign: _vm.align } },
    [
      _vm.columnType === "tag" && _vm.filter.show
        ? _c(
            "el-tag",
            {
              style: _vm.tagWidth ? { width: _vm.tagWidth } : {},
              attrs: {
                type: _vm.filter.type,
                color: _vm.filter.color,
                effect: "dark",
              },
            },
            [_vm._v(_vm._s(_vm.filter.label))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.columnType === "span"
        ? _c(
            "span",
            {
              staticClass: "filterText",
              class: _vm.filter.type,
              attrs: { title: _vm.filter.label },
            },
            [_vm._v(_vm._s(_vm.filter.label))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.columnType === "progress"
        ? _c("el-progress", {
            staticClass: "column-progress",
            attrs: { percentage: _vm.value },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }